<ng-container>
  <div class="mat-body">
    <mat-sidenav-container
      autosize
      fullscreen
      (backdropClick)="sidenav.close()"
    >
      <mat-sidenav
        #sidenav
        [ngClass]="{ 'sidenav-wide': expanded }"
        [disableClose]="'true'"
        [mode]="sideNavMode"
        [opened]="sideNavOpened"
        [position]="position"
      >
        <div
          fxLayout="column"
          fxFlexFill
          fxLayoutAlign="space-between stretch"
          class="sidenav-container unselectable"
        >
          <div class="hide-scrollbar">
            <!-- Header Brand -->
            <div class="sticky" [class.pl-60]="expanded">
              <div (click)="toggleSidenavMenu()">
                <ng-container *ngIf="expanded && !isMobile; else smallBrand">
                  <img class="brand-image" [src]="extendedHeaderImage" />
                  <mat-icon class="arrow" svgIcon="double_arrow_left"></mat-icon>
                </ng-container>

                <ng-template #smallBrand>
                  <ng-container *ngIf="!isMobile; else mobileBrand">
                    <img class="brand-image-small" [src]="minimizedHeaderImage" />
                    <mat-icon
                      class="arrow"
                      svgIcon="double_arrow_right"
                    ></mat-icon>
                  </ng-container>
                </ng-template>

                <ng-template #mobileBrand>
                  <img class="brand-image" [src]="extendedHeaderImage" />
                  <mat-icon class="arrow" svgIcon="double_arrow_right"></mat-icon>
                </ng-template>

                <hr />
              </div>
            </div>

            <ng-content select="[main]"></ng-content>
          </div>

          <!-- Footer Brand -->
          <mat-icon
            *ngIf="expanded"
            fxLayout="row"
            fxFlexAlign="end"
            class="bottom-brand-image"
            svgIcon="kronesLogo"
          >
          </mat-icon>
        </div>
      </mat-sidenav>
      <!----- App Bell ----->
      <ng-content select="pure-notification-skeleton"></ng-content>
      <!-- Mobile View -->
      <div class="content-shell" fxLayout="row" fxLayoutAlign="center start">
        <div fxFlexFill [ngClass]="{ site: isMobile }">
          <ng-content select="pure-sidenav-skeleton-router"></ng-content>
        </div>
        <mat-toolbar
          class="mobile-toolbar mat-elevation-z8"
          fxHide
          fxShow.xs
          fxLayout="row"
          fxLayoutAlign="space-evenly center"
        >
          <a mat-icon-button (click)="onProfileClicked()">
            <div>
              <s2a-wc-image-button
                [text]="userImageUrl ? '' : userInitials"
                [imageUrl]="userImageUrl"
              ></s2a-wc-image-button>
            </div>
          </a>
          <div class="pl-16" *ngIf="isAppBellSupported">
            <s2a-sidenav-list-item
              [isAppBellVisible]="isAppBellVisible"
              [icon]="'app-bell'"
              [badgeCount]="badgeCount"
              (itemClick)="onAppBellClicked()"
            >
            </s2a-sidenav-list-item>
          </div>
          <span fxFlex></span>
          <a
            mat-button
            class="button-navbar parallelogram"
            (click)="toggleSidenav()"
            fxLayoutAlign="center center"
          >
            <span class="skew-fix" fxLayoutAlign="center center">
              <div class="app-title">
                {{ activeAppName }}
              </div>
              <mat-icon>menu</mat-icon>
            </span>
          </a>
        </mat-toolbar>
      </div>
    </mat-sidenav-container>
  </div>
</ng-container>
